var render = function render(){var _vm=this,_c=_vm._self._c;return _c('VueShowdown',_vm._b({staticClass:"Markdown",class:{ hasStyles: _vm.hasStyles },attrs:{"markdown":_vm.markdown}},'VueShowdown',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }